import { Component, OnInit, Input, input } from '@angular/core';

@Component({
    selector: 'app-alert',
    templateUrl: './alert.component.html',
    styleUrls: ['./alert.component.css'],
    standalone: true
})
export class AlertComponent implements OnInit {

  constructor() { }
  // TODO: Skipped for migration because:
  //  Your application code writes to the input. This prevents migration.
  @Input() messageHeading: string;
  readonly message = input<string>(undefined);
  readonly msgtype = input<string>(undefined);
  iconclass = "fas fa-check"
  ngOnInit(): void {
    const msgtype = this.msgtype();
    if (msgtype == 'error') {
      this.iconclass = "fas fa-exclamation";
    }
    else if (msgtype == 'warn') {
      this.iconclass = "fas fa-exclamation";
    }
    else if (msgtype == 'info') {
      this.iconclass = "fas fa-info";
    }
    if (!this.messageHeading)
      this.messageHeading = 'Confirmed';
  }
}
